import React, { FC } from 'react';

import { Box, BoxProps, Center, HStack } from '@chakra-ui/react';
import { customTheme } from 'theme';

interface Props extends BoxProps {
  icon: React.ReactNode;
  description: string;
  iconSize?: string | number;
  spacing?: string | number;
}

export const InformationAlert: FC<Props> = props => {
  const { icon, description, iconSize = 8, spacing = 6, ...rest } = props;
  return (
    <Box
      w="full"
      borderRadius={6}
      py={3}
      px={6}
      bg="#fcf1d3"
      //border="1px solid"
      //borderColor={customTheme.colors.gray['100']}
      {...rest}
    >
      <HStack spacing={spacing}>
        <Box boxSize={iconSize}>
          <Center>{icon}</Center>
        </Box>
        <Box flex={1} fontSize="sm">
          {description}
        </Box>
      </HStack>
    </Box>
  );
};
